import React, { useEffect, useState } from 'react'
import { IconButton, blue500, v2neutral100 } from '@paypalcorp/pp-react'
import glamorous from 'glamorous'
import { css } from 'glamor'

// content
import getContent from 'pp-react-l10n'
import { showServiceError } from '../error/util'
const l10n = getContent('pages/seller/photos')

const ProfilePhoto = glamorous.div({
  position: 'absolute',
  bottom: '-60px',
  border: '4px solid white',
  backgroundColor: v2neutral100,
  borderRadius: '125px',
  height: '125px',
  width: '125px',
  left: '0px',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  '@media(max-width: 414px)': {
    borderRadius: '92px',
    height: '92px',
    width: '92px',
    bottom: '-46px',
    left: '16px',
  },
})

const ProfilePhotoEdit = glamorous.div({
  position: 'absolute',
  bottom: '-4px',
  backgroundColor: '#222324',
  borderBottomLeftRadius: '125px',
  borderBottomRightRadius: '125px',
  height: '62.5px',
  width: '125px',
  opacity: '80%',
  clipPath: 'inset(28% 0% 0% 0%)',
  border: '4px solid white',
  right: '-4px',
  '@media(max-width: 414px)': {
    borderBottomLeftRadius: '92px',
    borderBottomRightRadius: '92px',
    height: '46px',
    width: '92px',
  },
})

const ProfilePhotoCamera = css({
  position: 'absolute',
  left: '34px',
  top: '7px',
  '@media(max-width: 414px)': {
    left: '18px',
    top: '-4px',
  },
})

const ProfileCircle = (props) => {
  const { isEditable, sellerProfileState } = props

  const hasCachedPhoto = !!sellerProfileState.state.photoSettings
    .cachedDataProfilePhoto

  const [image, setImage] = useState(
    'https://www.paypalobjects.com/paypal-ui/icons/svg/v2-merchant.svg',
  )

  useEffect(() => {
    if (hasCachedPhoto) {
      setImage(sellerProfileState.state.photoSettings.cachedDataProfilePhoto)
    }
  })

  const backgroundImage = css({
    color: blue500,
    backgroundImage: `url('${image}')`,
    backgroundSize: `${hasCachedPhoto ? '100%' : '75px 75px'}`,
    '@media(max-width: 414px)': {
      backgroundSize: `${hasCachedPhoto ? '100%' : '55px 55px'}`,
    },
  })

  const hiddenFileInput = React.useRef(null)

  const handleClick = () => {
    hiddenFileInput.current.click()
  }

  const advanceToProfilePan = () => {
    sellerProfileState.loadCachedProfilePhoto()
    props.history.push('/seller/photos/profile')
  }

  const onChangeProfilePhoto = (event) => {
    // load the selected photo instead of what's cached
    sellerProfileState.scanProfilePhoto(
      event,
      () => {
        props.history.push('/seller/photos/profile')
      },
      () => {
        props.history.push({
          pathname: '/seller/error',
          state: {
            error: {
              headerKey: 'badPhoto',
              subHeaderKey: null,
              ctaButtonKey: 'badPhoto',
            },
          },
        })
      },
      (e) => {
        showServiceError(e, props.history)
      },
    )
  }

  return (
    <ProfilePhoto className={backgroundImage}>
      {isEditable && (
        <ProfilePhotoEdit>
          <IconButton
            inverse
            name="profile-cover"
            className={`${ProfilePhotoCamera}`}
            iconName="camera"
            onClick={hasCachedPhoto ? advanceToProfilePan : handleClick}
          >
            {l10n('a11y.profile.camera')}
          </IconButton>
          {!hasCachedPhoto && (
            <input
              type="file"
              onChange={onChangeProfilePhoto}
              ref={hiddenFileInput}
              style={{ display: 'none' }}
            />
          )}
        </ProfilePhotoEdit>
      )}
    </ProfilePhoto>
  )
}

export default ProfileCircle
